module.exports = __webpack_public_path__ + "img/c598816.jpg";